// Phase 18 · Community · Mini-landing embed card
import React from "react";
import { Link } from "react-router-dom";
import { Layers, ArrowRight } from "lucide-react";

export default function MiniLandingEmbedCard({ preview }) {
    if (!preview) return null;
    return (
        <div
            className="rounded-lg border border-[#FFFFFF]/20 bg-gradient-to-br from-[#FFFFFF]/5 to-[#111111] p-3 flex gap-3"
            data-testid={`mini-landing-embed-${preview.id}`}
        >
            {preview.thumbnail_url ? (
                <img
                    src={preview.thumbnail_url}
                    alt={preview.title}
                    className="w-16 h-16 rounded-lg object-cover border border-[#1A1A1A] flex-shrink-0"
                />
            ) : (
                <div className="w-16 h-16 rounded-lg bg-[#111111] border border-[#1A1A1A] flex items-center justify-center flex-shrink-0">
                    <Layers size={22} className="text-[#FFFFFF]" />
                </div>
            )}
            <div className="flex-1 min-w-0">
                <p className="text-[10px] uppercase tracking-widest text-[#FFFFFF] font-semibold mb-0.5">
                    Landing Page
                </p>
                <p className="text-sm font-semibold text-neutral-100 truncate">
                    {preview.title}
                </p>
                {preview.hero_subhead && (
                    <p className="text-xs text-neutral-400 line-clamp-1 mt-0.5">
                        {preview.hero_subhead}
                    </p>
                )}
                {preview.url && (
                    <Link
                        to={preview.url}
                        className="inline-flex items-center gap-1 text-xs text-[#FFFFFF] hover:text-[#CCCCCC] font-medium mt-1.5 transition-colors"
                    >
                        Open <ArrowRight size={12} />
                    </Link>
                )}
            </div>
        </div>
    );
}
